import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { GoogleAnalyticsService } from '../analytics/google-analytics.service';
import { Observable } from 'rxjs';
import { HttpConsts } from "../api/http-consts";
import { LocalStorageHelper } from "../services/localStorage-helper";
import { environment } from "src/environments/environment";
import { AuthService } from '../auth/auth.service';
import { ProfileQuery } from "../profile/state/profile.query";

@Injectable({
    providedIn: "root"
})
export class HttpHeadersInterceptor implements HttpInterceptor {
    public headers;
    private addWithCradentials = false;

    constructor(
        private analytics: GoogleAnalyticsService,
        private authService: AuthService,
        private profileQuery: ProfileQuery
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        this.headers = {};

        const isInternal = req.url.startsWith(`${environment.api.accessPointUrl}`);

        // Set Content-Type for:
        // - All non-GET requests (internal/external)
        // - Internal GET requests
        if (req.method !== 'GET' || isInternal) {
            if (req.body instanceof Array && req.body.every(item => item && item.hasOwnProperty('op') && item.hasOwnProperty('path'))) {
                this.headers['Content-Type'] = 'application/json-patch+json';
            }
            else if (req.body instanceof Object && req.body.hasOwnProperty('op') && req.body.hasOwnProperty('path')) {
                this.headers['Content-Type'] = 'application/json-patch+json';
            }
            else if (!(req.body instanceof FormData) && !(req.body instanceof Blob)) {
                // Skip FormData and Blob/File bodies — they carry their own Content-Type
                this.headers['Content-Type'] = 'application/json; charset=utf-8';
            }
        }

        this.addWithCradentials = false;
        this.handleHeader(req);

        const requestWithHeaders = req.clone({ setHeaders: this.headers, withCredentials: this.addWithCradentials });
        return next.handle(requestWithHeaders);
    }

    private handleHeader(req: HttpRequest<any>): void {
        if (req.url.startsWith(`${environment.api.accessPointUrl}`)) {
            this.addWithCradentials = true;
            const userId = this.authService.getLoggedInUserId();
            const companyId = this.getCompanyId(userId);

            // Add internal-only headers
            this.headers['session-id'] = this.analytics.getSessionId();
            this.setCompanyId(companyId);
        }
    }

    private getCompanyId(userId: string): string | undefined {
        const storedCompanyId = this.profileQuery.getCompanyId();

        return storedCompanyId ? storedCompanyId : LocalStorageHelper.getLastConnectedCompanyId(userId);
    }

    private setCompanyId(companyId: string): void {
        if (companyId) {
            this.headers[HttpConsts.companyId] = companyId;
        }
    }
}